export const Roles = {
    ADMIN: "Administratör",
    CONTACT_PERSON: "Kontaktperson",
    SURVEY_PROVIDER: "Enkätleverantör",
    ORG_MANAGER: "Verksamhetschef",
    READER: "Läsare",
    EXPORT_RAW: "ExportRådata",
    EXPORT_FREE_TEXT: "ExportFritext",
} as const;

export type Role = (typeof Roles)[keyof typeof Roles];
